<div class="box-content-sm explore">
  <div
    fxLayout="row"
    fxLayoutAlign="space-between start"
    fxLayoutGap="10px"
    style="display: flex; flex-direction: row; gap: 4px"
  >
    <mat-card
      class="mat-elevation-z8"
      fxFlex="75"
      fxLayout="column"
      style="width: 75%; padding: 16px"
    >
      <mat-card-title
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="10px"
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 8px;
        "
      >
        <menu-header [menuTopic]="graph"></menu-header>
      </mat-card-title>

      <div
        *ngIf="!chartOptions"
        fxLayout="column"
        fxLayoutAlign="center center"
        fxLayoutGap="10px"
        class="graph-nochart"
        style="
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 630px;
        "
      >
        <fa-icon [icon]="iconsolid.faMagnifyingGlassChart"></fa-icon>
        <span>{{ "view_value.please_select_data" | translate }}</span>
      </div>

      <div
        *ngIf="chartOptions"
        fxFlex="100"
        fxLayout="column"
        fxLayoutAlign="center strecth"
        fxLayoutGap="15px"
      >
        <div
          *ngIf="dataDetail && dataDetail.statistics"
          fxLayout="row nowrap"
          fxLayoutAlign="center center"
          fxLayoutGap="10px"
          style="font-size: 16; font-weight: bold"
        >
          <span
            >{{ "Name" }} : {{ dataDetail.name || dataDetail.meter_name }}</span
          >
          <span *ngIf="dataDetail.panel"
            >{{ "Panel" }} : {{ dataDetail.panel }}</span
          >
          <span *ngIf="dataDetail.period"
            >{{ "Period" }} : {{ dataDetail.period }}</span
          >
        </div>
        <div
          *ngIf="chartOptions"
          echarts
          [options]="chartOptions"
          [initOpts]="initOpts"
          style="height: 50vh"
        ></div>
        <app-table-display-data
          *ngIf="dataDetail && dataDetail.statistics"
          [data]="dataDetail?.statistics"
        ></app-table-display-data>
      </div>
    </mat-card>

    <mat-card
      class="mat-elevation-z8"
      fxFlex="25"
      fxLayout="column"
      fxLayoutAlign="start strecth"
      fxLayoutGap="10px"
      style="width: 25%; padding: 16px"
    >
      <mat-card-title
        fxLayout="row"
        fxLayoutAlign="space-between center"
        fxLayoutGap="10px"
      >
        <menu-header [menuTopic]="setting"></menu-header>
      </mat-card-title>

      <mat-tab-group>
        <mat-tab [label]="'view_value.custom' | translate">
          <form [formGroup]="customForm" (submit)="onSubmit('custom')">
            <div fxLayout="column" fxLayoutAlign="space-between">
              <div style="display: flex; flex-direction: column; gap: 24px">
                <div style="margin-bottom: 12px">
                  <div
                    style="
                      font-size: 13px;
                      font-weight: 500;
                      margin-bottom: 4px;
                    "
                  >
                    {{ "view_value.compare_by" | translate }}
                  </div>

                  <mat-button-toggle-group
                    formControlName="compareBy"
                    appearance="legacy"
                    style="width: 100%"
                  >
                    <mat-button-toggle value="meter" style="width: 50%">
                      Meter
                    </mat-button-toggle>
                    <mat-button-toggle value="parameter" style="width: 50%">
                      Parameter
                    </mat-button-toggle>
                  </mat-button-toggle-group>
                </div>

                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>{{
                    "view_value.sensor_type" | translate
                  }}</mat-label>
                  <mat-select formControlName="sensor_type">
                    @for (item of sensor_type_list; track item) {
                      <mat-option [value]="item">
                        {{ item | titlecase }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>

                <div *ngIf="customForm.get('compareBy')?.value === 'meter'">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>
                      {{ "view_value.meter_name" | translate }}
                    </mat-label>
                    <input
                      type="text"
                      matInput
                      formControlName="meter_name"
                      [matAutocomplete]="autoCustom"
                    />
                  </mat-form-field>
                  <mat-autocomplete
                    #autoCustom="matAutocomplete"
                    [displayWith]="displayFn"
                  >
                    <mat-option
                      *ngFor="let option of filteredOptionsCustom | async"
                      [value]="option"
                    >
                      {{ option.name
                      }}{{
                        option.description ? " | " + option.description : ""
                      }}
                    </mat-option>
                  </mat-autocomplete>
                </div>
                <div *ngIf="customForm.get('compareBy')?.value === 'meter'">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>
                      {{ "view_value.parameter" | translate }}
                    </mat-label>

                    <mat-chip-grid #chipList>
                      <mat-chip
                        *ngFor="let item of selectedParametersCustom"
                        [removable]="true"
                        (removed)="removeParameter(item, 'custom')"
                      >
                        {{ "view_value." + item | translate }}
                        <mat-icon matChipRemove>close</mat-icon>
                      </mat-chip>

                      <input
                        matInput
                        [formControl]="parameterCtrl"
                        [matAutocomplete]="auto"
                        [matChipInputFor]="chipList"
                      />
                    </mat-chip-grid>

                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option
                        *ngFor="let option of filteredParameters | async"
                        (click)="toggleParameter(option, 'custom')"
                      >
                        <mat-checkbox
                          class="checkbox-primary"
                          [checked]="isSelectedParameter(option, 'custom')"
                          (click)="$event.stopPropagation()"
                          (change)="toggleParameter(option, 'custom')"
                        >
                          {{ "view_value." + option | translate }}
                        </mat-checkbox>
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div
                  style="display: flex; flex-direction: column; gap: 24px"
                  *ngIf="customForm.get('compareBy')?.value === 'parameter'"
                >
                  <div>
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>{{
                        "view_value.parameter" | translate
                      }}</mat-label>
                      <mat-select
                        formControlName="parameter"
                        [disabled]="parameters_custom.length === 0"
                      >
                        <mat-option
                          *ngFor="let option of parameters_custom"
                          [value]="option"
                        >
                          {{ "view_value." + option | translate }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div>
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>{{
                        "view_value.meter_name" | translate
                      }}</mat-label>

                      <mat-chip-grid #chipMeterList>
                        <mat-chip
                          *ngFor="let item of selectedMetersCustom"
                          [removable]="true"
                          (removed)="removeMeter(item, 'custom')"
                        >
                          {{ item.name }}
                          <mat-icon matChipRemove>close</mat-icon>
                        </mat-chip>

                        <input
                          matInput
                          [formControl]="meterCtrl"
                          [matAutocomplete]="autoMeter"
                          [matChipInputFor]="chipMeterList"
                        />
                      </mat-chip-grid>

                      <mat-autocomplete #autoMeter="matAutocomplete">
                        <mat-option
                          *ngFor="let option of filteredMeterOptions | async"
                          (click)="toggleMeter(option, 'custom')"
                        >
                          <mat-checkbox
                            class="checkbox-primary"
                            [checked]="isSelectedMeter(option, 'custom')"
                            (click)="$event.stopPropagation()"
                            (change)="toggleMeter(option, 'custom')"
                          >
                            {{ option.name }}
                          </mat-checkbox>
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>
                </div>
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>{{
                    "view_value.date_range" | translate
                  }}</mat-label>

                  <mat-date-range-input [rangePicker]="picker1">
                    <input matStartDate formControlName="start_time" readonly />
                    <input matEndDate formControlName="end_time" readonly />
                  </mat-date-range-input>

                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker1"
                  ></mat-datepicker-toggle>
                  <mat-date-range-picker #picker1></mat-date-range-picker>
                </mat-form-field>
              </div>

              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-top: 16px;
                "
              >
                <button
                  [disabled]="!onDownload_custom"
                  mat-stroked-button
                  (click)="
                    onExportCSV(customForm.value, 'custom', dataExport_custom)
                  "
                >
                  {{ "view_value.download" | translate }} CSV
                </button>

                <button
                  class="submit"
                  type="submit"
                  mat-raised-button
                  class="submit"
                  [disabled]="isCustomDisabled"
                >
                  {{ "view_value.confirm" | translate }}
                </button>
              </div>
            </div>
          </form>
        </mat-tab>

        <mat-tab [label]="'view_value.period' | translate">
          <form
            [formGroup]="periodForm"
            (submit)="onSubmit('period')"
            style="height: 100%"
          >
            <div fxLayout="column" fxLayoutAlign="space-between">
              <div style="display: flex; flex-direction: column; gap: 24px">
                <div class=" ">
                  {{
                    periodForm.get("sensor_type")?.value === "energy"
                      ? "Active Energy (kWh)"
                      : "Active Water"
                  }}
                </div>
                <!-- <div style="margin-bottom: 12px">
                  <div
                    style="
                      font-size: 13px;
                      font-weight: 500;
                      margin-bottom: 4px;
                    "
                  >
                    {{ "view_value.compare_by" | translate }}
                  </div>

                  <mat-button-toggle-group
                    formControlName="compareBy"
                    appearance="legacy"
                    style="width: 100%"
                  >
                    <mat-button-toggle value="meter" style="width: 50%">
                      Meter
                    </mat-button-toggle>
                    <mat-button-toggle value="parameter" style="width: 50%">
                      Parameter
                    </mat-button-toggle>
                  </mat-button-toggle-group>
                </div> -->

                <mat-form-field
                  appearance="outline"
                  style="width: 100%; margin-top: 4px"
                >
                  <mat-label>{{
                    "view_value.sensor_type" | translate
                  }}</mat-label>
                  <mat-select formControlName="sensor_type">
                    @for (item of sensor_type_list; track item) {
                      <mat-option [value]="item">
                        {{ item | titlecase }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>

                <div *ngIf="periodForm.get('compareBy')?.value === 'meter'">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>
                      {{ "view_value.meter_name" | translate }}
                    </mat-label>
                    <input
                      type="text"
                      matInput
                      formControlName="meter_name"
                      [matAutocomplete]="autoPeriodMeter"
                      [disabled]="meterlistPeriod.length === 0"
                    />
                  </mat-form-field>
                  <mat-autocomplete
                    #autoPeriodMeter="matAutocomplete"
                    [displayWith]="displayFn"
                  >
                    <mat-option
                      *ngFor="let option of filteredMeterOptions | async"
                      [value]="option"
                    >
                      {{ option.name
                      }}{{
                        option.description ? " | " + option.description : ""
                      }}
                    </mat-option>
                  </mat-autocomplete>
                </div>
                <div *ngIf="periodForm.get('compareBy')?.value === 'meter'">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>
                      {{ "view_value.parameter" | translate }}
                    </mat-label>

                    <mat-chip-grid #chipList>
                      <mat-chip
                        *ngFor="let item of selectedParametersPeriod"
                        [removable]="true"
                        (removed)="removeParameter(item, 'period')"
                      >
                        {{ item.view_value }}
                        <mat-icon matChipRemove>close</mat-icon>
                      </mat-chip>

                      <input
                        matInput
                        [formControl]="parameterCtrl"
                        [matAutocomplete]="auto"
                        [matChipInputFor]="chipList"
                        [disabled]="parameters_custom.length === 0"
                      />
                    </mat-chip-grid>

                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option
                        *ngFor="let option of filteredParameters | async"
                        (click)="toggleParameter(option, 'period')"
                      >
                        <mat-checkbox
                          class="checkbox-primary"
                          [checked]="isSelectedParameter(option, 'period')"
                          (click)="$event.stopPropagation()"
                          (change)="toggleParameter(option, 'period')"
                        >
                          {{ option.view_value }}
                        </mat-checkbox>
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div style="display: flex; flex-direction: column; gap: 24px">
                  <!-- <div>
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>{{
                        "view_value.parameter" | translate
                      }}</mat-label>
                      <mat-select formControlName="parameter">
                        <mat-option
                          *ngFor="let option of parameters_custom"
                          [value]="option.value"
                        >
                          {{ option.view_value }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div> -->

                  <div>
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>
                        {{ "view_value.meter_name" | translate }}
                      </mat-label>

                      <input
                        type="text"
                        matInput
                        formControlName="meter_name"
                        [matAutocomplete]="autoPeriod"
                      />
                    </mat-form-field>

                    <mat-autocomplete
                      #autoPeriod="matAutocomplete"
                      [displayWith]="displayFn"
                    >
                      <mat-option
                        *ngFor="let option of filteredOptionsPeriod | async"
                        [value]="option"
                      >
                        {{ option.name }}
                        {{
                          option.description ? " | " + option.description : ""
                        }}
                      </mat-option>
                    </mat-autocomplete>
                  </div>
                </div>
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>
                    {{ "view_value.period" | translate }}
                  </mat-label>
                  <mat-select formControlName="period">
                    <mat-option
                      *ngFor="let items of period"
                      [value]="items.value"
                    >
                      {{ items.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-top: 16px;
                "
              >
                <button
                  [disabled]="!onDownload_period"
                  mat-stroked-button
                  (click)="onExportCSV(periodForm.value, 'period', dataExport)"
                >
                  {{ "view_value.download" | translate }} CSV
                </button>

                <button
                  class="submit"
                  type="submit"
                  mat-raised-button
                  class="submit"
                  [disabled]="isPeriodDisabled"
                >
                  {{ "view_value.confirm" | translate }}
                </button>
              </div>
            </div>
          </form>
        </mat-tab>
      </mat-tab-group>
    </mat-card>
  </div>
</div>
